export default __webpack_public_path__ + "static/media/WizardEmoji2.9ccf6cc5.png";